export default {
	"2452df73ddcc2d463b81cbb716eab2ab": "提示",
	"218cb5f1a785eed01f250ae57202653d": "前往微信小程序支付",
	"254670231519fcaf766027eff379862a": "即將跳轉微信小程序"
}
